;(function () {
  angular.module('contrast.loading').directive('loading', function () {
    return {
      restrict: 'E',
      transclude: true,
      scope: { text: '@text' },
      replace: true,
      template:
        '<div class="page"><i class="fa fa-spinner fa-pulse fa-spin"></i> {{text}}</div>'
    }
  })
})()
